/**
 * SeekKey Custom Variant Picker
 * - Custom styled dropdown
 * - Inline notify-me for out-of-stock (replaces buy button inline)
 * - Pre-order support via disponibilidade metafield
 */
(function () {
  "use strict";

  var qs  = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var qsa = function (sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  // ── Aluguel PSN (acesso secundário com prazo de 15 dias) ──
  // Normaliza pra comparar sem depender de acento/caixa ("Secundária" x "Secundaria").
  function skNormalize(str) {
    var s = String(str == null ? "" : str).toLowerCase();
    try { s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); } catch (e) {}
    return s;
  }

  // Detecta aluguel por PREFIXO em cada segmento do título da variante
  // ("Aluguel 15 dias - Secundária", "PS5 / Aluguel 15 dias - Secundaria").
  // Prefixo e não substring: evita falso positivo se a palavra aparecer no meio do texto.
  function isAluguelVariant(name) {
    return skNormalize(name).split("/").some(function (part) {
      return part.trim().indexOf("aluguel") === 0;
    });
  }

  // O selo de USP em buy-buttons.liquid é Liquid estático ("Suporte 180 dias") e não vale
  // pro aluguel, então a troca é feita no cliente conforme a variante escolhida.
  // Só o nó de texto muda (o SVG do span continua intacto) e o texto original fica guardado
  // em data-sk-usp-original, que é SEMPRE a base da comparação: assim reaplicar a função não
  // reprocessa texto já trocado, e voltar pra variante permanente restaura o original.
  //
  // Casamento robusto de propósito: a versão anterior procurava o literal "180" no texto e
  // por isso ficou MUDA num tema cuja copy dizia "Suporte 7 dias" — quebra silenciosa, que
  // é o pior tipo. Agora cada slot é achado por PAPEL (prefixo do texto original,
  // normalizado sem acento e sem caixa), com fallback por POSIÇÃO na barra, e avisa no
  // console quando a copy não bate mais, em vez de falhar sem deixar rastro.
  var SK_USP_SLOTS = [
    // ordem importa: o primeiro span que casar leva o slot
    { prefixo: "suporte",  posicao: 2, aluguel: "Acesso por 15 dias" },
    { prefixo: "garantia", posicao: 1, aluguel: "Suporte durante o aluguel" }
  ];

  function skUspAviso(msg) {
    if (window.console && typeof console.warn === "function") console.warn("[seekkey] " + msg);
  }

  // Memoriza o texto original do span e devolve o nó de texto (ou null se não houver).
  function skUspTextNode(span) {
    var node = span.lastChild;
    if (!node || node.nodeType !== 3) return null; // 3 = nó de texto
    if (typeof span.dataset.skUspOriginal !== "string") span.dataset.skUspOriginal = node.nodeValue;
    return node;
  }

  function applyUspForVariant(scope, isAluguel) {
    try {
      var usp = qs(".sk-guarantee-usp", scope) || qs(".sk-guarantee-usp");
      if (!usp) return; // página sem barra de USP: nada a fazer, e nada quebra

      var spans = qsa("span", usp).filter(function (s) { return s.parentNode === usp; });
      if (!spans.length) return;

      // 1) grava o original de cada span ANTES de qualquer troca
      var nodes = spans.map(skUspTextNode);

      // 2) resolve cada slot: prefixo primeiro, posição como rede
      var alvo = {}, porPosicao = [];
      SK_USP_SLOTS.forEach(function (slot) {
        var idx = -1, i;
        for (i = 0; i < spans.length; i++) {
          if (!nodes[i] || alvo[i] !== undefined) continue;
          if (skNormalize(spans[i].dataset.skUspOriginal).trim().indexOf(slot.prefixo) === 0) { idx = i; break; }
        }
        if (idx === -1 && nodes[slot.posicao] && alvo[slot.posicao] === undefined) {
          idx = slot.posicao;
          porPosicao.push(slot.prefixo);
        }
        if (idx !== -1) alvo[idx] = slot.aluguel;
      });

      if (isAluguel && porPosicao.length) {
        skUspAviso('selo de USP: slot(s) "' + porPosicao.join('", "') +
                   '" não casaram por texto e foram resolvidos por posição. A copy de ' +
                   'buy-buttons.liquid provavelmente mudou; confira SK_USP_SLOTS.');
      }
      if (isAluguel && !Object.keys(alvo).length) {
        skUspAviso("selo de USP não reconhecido; o texto do aluguel não foi aplicado.");
        return; // melhor não trocar do que trocar o selo errado
      }

      // 3) aplica no aluguel, restaura o original nas variantes permanentes
      spans.forEach(function (span, i) {
        var node = nodes[i];
        if (!node) return;
        var texto = (isAluguel && alvo[i] !== undefined) ? alvo[i] : span.dataset.skUspOriginal;
        if (node.nodeValue !== texto) node.nodeValue = texto;
      });
    } catch (e) {
      // decorativo: um erro aqui não pode abortar o resto do handler de variante
      // (é ele que monta os selos de entrega logo depois).
      skUspAviso("falha ao ajustar o selo de USP: " + (e && e.message ? e.message : e));
    }
  }

  // ── Dropdown ──
  function openDropdown(dd) {
    qsa(".sk-custom-dropdown.is-open").forEach(function (d) { if (d !== dd) closeDropdown(d); });
    dd.classList.add("is-open");
    var trigger = qs(".sk-custom-dropdown__trigger", dd);
    if (trigger) trigger.setAttribute("aria-expanded", "true");
  }

  function closeDropdown(dd) {
    dd.classList.remove("is-open");
    var trigger = qs(".sk-custom-dropdown__trigger", dd);
    if (trigger) trigger.setAttribute("aria-expanded", "false");
  }

  function selectOption(optEl) {
    var dd = optEl.closest(".sk-custom-dropdown");
    if (!dd) return;
    var selectId = dd.dataset.selectId;
    var nativeSelect = document.getElementById(selectId);
    var value = optEl.dataset.value;
    var nameEl = qs(".sk-custom-dropdown__option-name", optEl);
    var displayEl = qs(".sk-custom-dropdown__selected", dd);
    qsa(".sk-custom-dropdown__option", dd).forEach(function (o) {
      o.classList.toggle("is-selected", o === optEl);
      o.setAttribute("aria-selected", String(o === optEl));
    });
    if (displayEl && nameEl) displayEl.textContent = nameEl.textContent.trim();
    if (nativeSelect && nativeSelect.value !== value) {
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
    closeDropdown(dd);
  }

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest(".sk-custom-dropdown__trigger");
    if (trigger) { e.preventDefault(); var dd = trigger.closest(".sk-custom-dropdown"); dd.classList.contains("is-open") ? closeDropdown(dd) : openDropdown(dd); return; }
    var opt = e.target.closest(".sk-custom-dropdown__option");
    if (opt) { selectOption(opt); return; }
    if (!e.target.closest(".sk-custom-dropdown")) qsa(".sk-custom-dropdown.is-open").forEach(closeDropdown);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") qsa(".sk-custom-dropdown.is-open").forEach(closeDropdown);
  });

  // ── Notify-Me helpers ──
  // Staging Supabase — tema staging NUNCA pode apontar pro projeto de produção
  var SUPABASE_URL = "https://filtorboegtoodfpbswl.supabase.co";
  var SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZpbHRvcmJvZWd0b29kZnBic3dsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4NTQxOTksImV4cCI6MjA4ODQzMDE5OX0.jsgNh_XFH7JMtgJH9G5Z3OFGSEE9RdZ1cjhPdo-DabU";

  function getLoggedInEmail() {
    try {
      var cookie = document.cookie.split(";").find(function(c) { return c.trim().startsWith("sk_customer="); });
      if (!cookie) return null;
      var decoded = decodeURIComponent(cookie.split("=")[1]);
      var data = JSON.parse(decoded);
      return data.email || null;
    } catch(e) { return null; }
  }

  function saveNotifyEmail(email, variantId, productTitle) {
    var cleanTitle = (productTitle || "").replace(/\s+/g, " ").trim();
    var words = cleanTitle.split(" ");
    if (words.length >= 4 && words.length % 2 === 0) {
      var half = words.length / 2;
      if (words.slice(0, half).join(" ") === words.slice(half).join(" ")) cleanTitle = words.slice(0, half).join(" ");
    }
    return fetch(SUPABASE_URL + "/rest/v1/product_alerts", {
      method: "POST",
      headers: {
        "apikey": SUPABASE_ANON,
        "Authorization": "Bearer " + SUPABASE_ANON,
        "Content-Type": "application/json",
        "Prefer": "return=minimal"
      },
      body: JSON.stringify({ email: email, variant_id: String(variantId), product_title: cleanTitle })
    }).then(function(resp) {
      if (resp.status === 409 || resp.ok) return resp;
      throw new Error("save failed");
    });
  }
  // PORTAL resolvido via sk-config.liquid (window.SK_PORTAL). Fallback: prod.
  var PORTAL_BASE = (typeof window !== "undefined" && window.SK_PORTAL) || "https://secure.seekkey.com.br";

  function checkExistingAlert(email, variantId) {
    if (!email) return Promise.resolve(false);
    return fetch(PORTAL_BASE + "/api/conta/alerts/check?email=" + encodeURIComponent(email) + "&variant_id=" + encodeURIComponent(String(variantId)))
      .then(function(resp) { return resp.json(); })
      .then(function(data) { return data && data.exists === true; })
      .catch(function() { return false; });
  }
  function cancelAlert(variantId) {
    return fetch(PORTAL_BASE + "/api/conta/alerts/" + encodeURIComponent(String(variantId)), {
      method: "DELETE",
      credentials: "include"
    }).then(function(resp) {
      if (!resp.ok) throw new Error("cancel failed");
      return resp;
    });
  }



  // ── Build notify UI using safe DOM methods ──
  function createSvgIcon(type) {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "18"); svg.setAttribute("height", "18");
    svg.setAttribute("viewBox", "0 0 24 24"); svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", type === "email" ? "#0a0c1a" : "currentColor");
    svg.setAttribute("stroke-width", "2"); svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");
    if (type === "email") {
      var p = document.createElementNS("http://www.w3.org/2000/svg", "path");
      p.setAttribute("d", "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z");
      var poly = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
      poly.setAttribute("points", "22,6 12,13 2,6");
      svg.appendChild(p); svg.appendChild(poly);
    } else {
      var l = document.createElementNS("http://www.w3.org/2000/svg", "line");
      l.setAttribute("x1","22");l.setAttribute("y1","2");l.setAttribute("x2","11");l.setAttribute("y2","13");
      var pg = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
      pg.setAttribute("points","22 2 15 22 11 13 2 9 22 2");
      svg.appendChild(l); svg.appendChild(pg);
    }
    return svg;
  }

  function buildLoggedInNotify(variantId, productTitle) {
    var div = document.createElement("div");
    div.className = "sk-notify-inline";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "sk-notify-inline__btn product-form__submit button button--full-width sk-btn-buy-now";
    btn.style.cssText = "display:flex!important";
    var icon = createSvgIcon("email");
    icon.classList.add("mr-4");
    var span = document.createElement("span");
    span.textContent = "Avise-me quando disponivel";
    btn.appendChild(icon); btn.appendChild(span);
    div.appendChild(btn);
    var email = getLoggedInEmail();
    var isSubscribed = false;

    function setSubscribedState() {
      isSubscribed = true;
      span.textContent = "Voce sera avisado (cancelar)";
      btn.style.background = "#23194c"; btn.style.color = "#CBFF2E";
      btn.style.border = "1px solid #CBFF2E";
      btn.disabled = false;
    }

    function setUnsubscribedState() {
      isSubscribed = false;
      span.textContent = "Avise-me quando disponivel";
      btn.style.background = ""; btn.style.color = "";
      btn.style.border = "";
      btn.disabled = false;
    }

    btn.addEventListener("click", function() {
      if (isSubscribed) {
        btn.disabled = true; span.textContent = "Cancelando...";
        cancelAlert(variantId)
          .then(function() { setUnsubscribedState(); })
          .catch(function() { span.textContent = "Erro ao cancelar."; btn.disabled = false; });
      } else {
        btn.disabled = true; span.textContent = "Salvando...";
        saveNotifyEmail(email, variantId, productTitle)
          .then(function() { setSubscribedState(); })
          .catch(function() { span.textContent = "Erro. Tente novamente."; btn.disabled = false; });
      }
    });

    if (email) {
      checkExistingAlert(email, variantId).then(function(exists) {
        if (exists) setSubscribedState();
      });
    }
    return div;
  }

  function buildGuestNotify(variantId, productTitle) {
    var div = document.createElement("div");
    div.className = "sk-notify-inline";
    var row = document.createElement("div");
    row.className = "sk-notify-inline__row";
    var input = document.createElement("input");
    input.type = "email"; input.className = "sk-notify-inline__input";
    input.placeholder = "Seu e-mail"; input.setAttribute("aria-label", "Seu e-mail");
    var sendBtn = document.createElement("button");
    sendBtn.type = "button"; sendBtn.className = "sk-notify-inline__btn-send";
    sendBtn.appendChild(createSvgIcon("send"));
    row.appendChild(input); row.appendChild(sendBtn);
    div.appendChild(row);
    sendBtn.addEventListener("click", function() {
      var email = input.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        input.style.borderColor = "#ff4444"; input.placeholder = "Digite um e-mail válido"; return;
      }
      sendBtn.disabled = true; input.disabled = true;
      saveNotifyEmail(email, variantId, productTitle)
        .then(function() {
          div.textContent = "";
          var p = document.createElement("p");
          p.className = "sk-notify-inline__success";
          p.textContent = "Pronto! Você será avisado quando disponível.";
          div.appendChild(p);
        })
        .catch(function() { sendBtn.disabled = false; input.disabled = false; });
    });
    input.addEventListener("keypress", function(e) { if (e.key === "Enter") sendBtn.click(); });
    return div;
  }

  // ── Variant change handler ──
  function handleVariantChange(data) {
    var variant = data.variant;
    var sectionId = data.sectionId;
    var productInfo = qs("product-info[data-section=\"" + sectionId + "\"]");
    if (!productInfo) return;
    var buyBtn = qs(".product-form__submit", productInfo);
    var btnSpan = buyBtn ? qs("span", buyBtn) : null;
    var formButtons = qs(".product-form__buttons", productInfo);
    if (!buyBtn || !btnSpan || !formButtons) return;
    var disponibilidade = (productInfo.dataset.disponibilidade || "").trim();
    var existing = qs(".sk-notify-inline", formButtons);
    if (existing) existing.remove();
    var oldBlock = qs("#sk-notify-" + sectionId);
    if (oldBlock) oldBlock.remove();
    if (!variant) return;
    // Selo de USP acompanha a variante escolhida (aluguel não tem os 180 dias).
    // Fica antes do split disponível/indisponível pra valer nos dois casos.
    applyUspForVariant(productInfo, isAluguelVariant(variant.title || variant.name || ""));
    // Always clean up badge first
    var existingBadge = qs(".sk-delivery-badge", formButtons);
    if (existingBadge) existingBadge.remove();
    if (variant.available) {
      buyBtn.disabled = false; buyBtn.style.display = "";
      btnSpan.textContent = disponibilidade === "pre_venda" ? "Pré-venda" : "Comprar agora";
      var varTitle = (variant.title || variant.name || "").toLowerCase();
      var isPrimaria = varTitle.includes("prim");
      if (disponibilidade === "sob_encomenda" && isPrimaria) {
        var badge = document.createElement("div");
        badge.className = "sk-delivery-badge";
        badge.style.cssText = "display:flex;align-items:center;justify-content:center;gap:5px;padding:0;margin:-6px 0 4px;font-size:12px;color:rgba(255,255,255,0.45);";
        var clockSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        clockSvg.setAttribute("width", "13"); clockSvg.setAttribute("height", "13");
        clockSvg.setAttribute("viewBox", "0 0 24 24"); clockSvg.setAttribute("fill", "none");
        clockSvg.setAttribute("stroke", "rgba(255,255,255,0.4)"); clockSvg.setAttribute("stroke-width", "2");
        var circ = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circ.setAttribute("cx","12"); circ.setAttribute("cy","12"); circ.setAttribute("r","10");
        var poly = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
        poly.setAttribute("points","12 6 12 12 16 14");
        clockSvg.appendChild(circ); clockSvg.appendChild(poly);
        var txt = document.createElement("span");
        txt.textContent = "Entrega em ate 24h uteis";
        badge.appendChild(clockSvg); badge.appendChild(txt);
        buyBtn.parentNode.insertBefore(badge, buyBtn);
      }
    } else {
      buyBtn.style.display = "none";
      var productTitle = "";
      var titleEl = qs(".product__title", productInfo);
      if (titleEl) productTitle = titleEl.textContent.trim();
      var notifyDiv = getLoggedInEmail()
        ? buildLoggedInNotify(variant.id, productTitle)
        : buildGuestNotify(variant.id, productTitle);
      buyBtn.insertAdjacentElement("afterend", notifyDiv);
    }
  }

  function trySubscribe() {
    if (typeof subscribe === "undefined" || typeof PUB_SUB_EVENTS === "undefined") {
      setTimeout(trySubscribe, 250); return;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) { handleVariantChange(event.data); });
  }

  function checkInitialState() {
    var productInfos = qsa("product-info[data-section]");
    productInfos.forEach(function(pi) {
      var buyBtn = qs(".product-form__submit", pi);
      if (!buyBtn) return;
      var formButtons = qs(".product-form__buttons", pi);
      if (!formButtons) return;
      // Check if button is disabled (variant not available)
      // Check for sob_encomenda badge on enabled buttons too
      var dispAttr = (pi.dataset.disponibilidade || "").trim();
      var selOpt = qs(".sk-custom-dropdown__option.is-selected", pi) || qs("select[name=id] option:checked", pi);
      // Prefere o nome puro da opção: o textContent do <li> inteiro traz legenda e preço junto
      var selNameEl = selOpt ? qs(".sk-custom-dropdown__option-name", selOpt) : null;
      var selRaw = selOpt ? ((selNameEl || selOpt).textContent || "") : "";
      var selTitle = selRaw.toLowerCase();
      var isPrimInit = selTitle.includes("prim");
      // Carga inicial (link direto pra variante de aluguel) também precisa do selo certo
      applyUspForVariant(pi, isAluguelVariant(selRaw));
      if (dispAttr === "sob_encomenda" && !buyBtn.disabled && isPrimInit) {
        var existBadge = qs(".sk-delivery-badge", formButtons);
        if (!existBadge) {
          var b = document.createElement("div");
          b.className = "sk-delivery-badge";
          b.style.cssText = "display:flex;align-items:center;justify-content:center;gap:5px;padding:0;margin:-6px 0 4px;font-size:12px;color:rgba(255,255,255,0.45);";
          var sv = document.createElementNS("http://www.w3.org/2000/svg","svg");
          sv.setAttribute("width","13");sv.setAttribute("height","13");sv.setAttribute("viewBox","0 0 24 24");
          sv.setAttribute("fill","none");sv.setAttribute("stroke","rgba(255,255,255,0.4)");sv.setAttribute("stroke-width","2");
          var c2=document.createElementNS("http://www.w3.org/2000/svg","circle");c2.setAttribute("cx","12");c2.setAttribute("cy","12");c2.setAttribute("r","10");
          var p2=document.createElementNS("http://www.w3.org/2000/svg","polyline");p2.setAttribute("points","12 6 12 12 16 14");
          sv.appendChild(c2);sv.appendChild(p2);
          var t2=document.createElement("span");t2.textContent="Entrega em ate 24h uteis";
          b.appendChild(sv);b.appendChild(t2);
          buyBtn.parentNode.insertBefore(b, buyBtn);
        }
      }
      if (buyBtn.disabled || buyBtn.getAttribute("disabled") !== null) {
        var existing = qs(".sk-notify-inline", formButtons);
        if (existing) return; // already handled
        var productTitle = "";
        var titleEl = qs(".product__title", pi);
        if (titleEl) productTitle = titleEl.textContent.trim();
        // Get variant ID from the form or URL
        var variantId = "";
        var variantInput = qs("input[name=id]", pi) || qs("select[name=id]", pi);
        if (variantInput) variantId = variantInput.value;
        if (!variantId) { var urlMatch = location.search.match(/variant=(d+)/); if (urlMatch) variantId = urlMatch[1]; }
        buyBtn.style.display = "none";
        var notifyDiv = getLoggedInEmail()
          ? buildLoggedInNotify(variantId, productTitle)
          : buildGuestNotify(variantId, productTitle);
        buyBtn.insertAdjacentElement("afterend", notifyDiv);
      }
    });
  }

  function init() { trySubscribe(); setTimeout(checkInitialState, 500); setTimeout(checkInitialState, 1500); setTimeout(checkInitialState, 3000); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();